import React from "react";
import { Helmet } from "react-helmet-async";
import Features from "../../components/widgets/features/Features";
import Hero from "../../components/widgets/Hero/Hero";
import "./Home.scss";

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <title>ARYN Lyrics (Арін Лірікс) — Цифровий пісенник для церков і команд прославлення</title>
        <meta name="description" content="Арін Лірікс — християнські пісні, тексти та акорди у цифровому пісеннику нового покоління для церков і команд прославлення. Створюйте власні пісенники, готуйте добірки для служіння, діліться з командою." />
        <meta name="keywords" content="ARYN Lyrics, Арін Лірікс, християнські пісні, тексти пісень, акорди, пісенник, прославлення, церква, команда прославлення, цифровий пісенник" />
        <link rel="canonical" href="https://aryn-lyrics.com/" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Hero />
      <Features />
    </div>
  );
};

export default Home;